<template>
<div v-if="message" class="alert alert-dismissible" v-bind:class="alertType" role="alert">
  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
  <strong>Warning!</strong> {{message}}
</div>
</template>


<script>

export default {
    name: 'alert',
    props: {
        message: String,
        type: String
    },
    data(){
        return {
        }
    },
    computed: {
        alertType: function(){
            
            return this.type
        }
    }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// Alert.vue?29e96506